module.exports = __webpack_public_path__ + "img/0.3a884cfd.gif";